var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDilate = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 9,
  y: 9,
  width: 6,
  height: 6,
  rx: 1,
  stroke: "#FFFFFF",
  strokeWidth: 1.2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7 7 4 4M4 4h3M4 4v3",
  stroke: "#FFFFFF",
  strokeWidth: 1.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M17 7 20 4M20 4h-3M20 4v3",
  stroke: "#FFFFFF",
  strokeWidth: 1.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M7 17 4 20M4 20h3M4 20v-3",
  stroke: "#FFFFFF",
  strokeWidth: 1.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M17 17 20 20M20 20h-3M20 20v-3",
  stroke: "#FFFFFF",
  strokeWidth: 1.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDilate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "415fe8b17c0a4c551c9bbed7b90393cb.svg";